import {
  formatDateTimeToApplicationDateTime
} from 'utilities/date';

export function formatLastUpdatedAt(lastUpdatedAt) {

  return formatDateTimeToApplicationDateTime(new Date(+lastUpdatedAt));

}